import { render, staticRenderFns } from "./campaigns-sort.vue?vue&type=template&id=5f1fbbf3&scoped=true&"
import script from "./campaigns-sort.vue?vue&type=script&lang=js&"
export * from "./campaigns-sort.vue?vue&type=script&lang=js&"
import style0 from "./campaigns-sort.vue?vue&type=style&index=0&id=5f1fbbf3&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f1fbbf3",
  null
  
)

export default component.exports